import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "23",
  fill: "none",
  viewBox: "0 0 24 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M4.566 3.305c0-.72.575-1.303 1.284-1.303h5.884c.34 0 .667.137.908.382l8.982 9.117a1.316 1.316 0 0 1 0 1.842l-5.884 5.973a1.27 1.27 0 0 1-1.815 0l-8.983-9.117a1.312 1.312 0 0 1-.376-.921V3.305Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M3.283 9.929c0 .345.135.677.376.92l9.57 9.714-.056.056a1.27 1.27 0 0 1-1.815 0L2.376 11.5a1.312 1.312 0 0 1-.376-.92V4.606c0-.72.575-1.302 1.283-1.302v6.624Z"
    }, null, -1)
  ]))]))
}
export default { render: render }